export const ALL_STORYBLOK_LANGUAGES = ['default', 'de', 'fr']
export default ALL_STORYBLOK_LANGUAGES

// The languages whose pages are published under a /<lang>/ path prefix
export const PREFIXED_STORYBLOK_LANGUAGES = ALL_STORYBLOK_LANGUAGES.filter(lang => lang !== 'default')

export enum LANGUAGE {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
}

// Note: The actual default language will be determined at runtime
export const defaultLanguage = LANGUAGE.EN

export const INTERNAL_LANGUAGES: LANGUAGE[] = (() =>
  ALL_STORYBLOK_LANGUAGES.map(lang => {
    const language = lang === 'default' ? defaultLanguage.toUpperCase() : lang.toUpperCase()
    return LANGUAGE[language]
  }))()

// Languages included in sitemap and hreflang tags (publicly available).
// Add new languages here when they go live.
export const SEO_PUBLIC_LANGUAGES: LANGUAGE[] = [LANGUAGE.DE]

// Languages excluded from sitemap and indexing (not yet public).
export const SEO_EXCLUDED_LANGUAGES: LANGUAGE[] = [LANGUAGE.FR]

export const langLabelMap = {
  [LANGUAGE.EN]: 'English',
  [LANGUAGE.DE]: 'Deutsch',
  [LANGUAGE.FR]: 'Français',
}

/** Check whether a lang key represents the default (English) language. */
export const isDefaultLanguage = (lang?: string): boolean => {
  const l = lang?.toLowerCase()
  return !l || l === 'default' || l === defaultLanguage
}

// This will be used to determine the initial language
export let runtimeDefaultLanguage = defaultLanguage

export const setRuntimeDefaultLanguage = (lang: LANGUAGE) => {
  runtimeDefaultLanguage = lang
}
